import { Action } from '@ngrx/store';
import { AssessmentPageInterface } from 'app/assessment/models';
import { RecommendationTemplateInterface } from 'app/recommendation/models';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';
import { RecommendationInterface } from 'app/recommendation/models/recommendation.model';

import { RecommendationServiceFilters } from '../../services/recommendation.service';

import { RecommendationActionType } from './recommendation-action-type.enum';

export class LoadEmployeeRecommendations implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadEmployeeRecommendations;

  constructor(public readonly payload?: RecommendationServiceFilters) { }
}

export class LoadEmployeeRecommendationsCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadEmployeeRecommendationsCompleted;

  constructor(public readonly payload: RecommendationInterface[]) { }
}

export class LoadEmployeeRecommendationsFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadEmployeeRecommendationsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadRecommendationTemplate implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationTemplate;

  constructor(public readonly payload: number) { }
}

export class LoadRecommendationTemplateCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationTemplateCompleted;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class LoadRecommendationTemplateFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationTemplateFailed;

  constructor(public readonly payload: string) { }
}

export class LoadRecommendationsLibrary implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationsLibrary;

  public readonly payload: any = undefined;
}

export class LoadRecommendationsLibraryCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationsLibraryCompleted;

  constructor(public readonly payload: RecommendationCategoryInterface[]) { }
}

export class LoadRecommendationsLibraryFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadRecommendationsLibraryFailed;

  constructor(public readonly payload: string) { }
}

export class LoadAssessmentQuestions implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadAssessmentQuestions;

  public readonly payload: any = undefined;
}

export class LoadAssessmentQuestionsCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadAssessmentQuestionsCompleted;

  constructor(public readonly payload: AssessmentPageInterface[]) { }
}

export class LoadAssessmentQuestionsFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.LoadAssessmentQuestionsFailed;

  constructor(public readonly payload: string) { }
}
